import firebase from '@/plugins/firebase'
import { User } from '@/types/User'
import Vote from '@/types/Vote'
import DocumentData = firebase.firestore.DocumentData;
import Firestore = firebase.firestore.Firestore;

export default class APIUser {
  static async signIn (): Promise<firebase.auth.UserCredential> {
    return await firebase.auth().signInAnonymously()
  }

  static async fetchUser (partyID: string, userID: string): Promise<firebase.firestore.DocumentSnapshot<DocumentData>> {
    return await firebase.firestore().collection('partyrooms').doc(String(partyID)).collection('users').doc(String(userID)).get()
  }

  static async voteForSong (partyID: string, vote: Vote): Promise<string> {
    const voteSnap = await firebase.firestore().collection('partyrooms').doc(String(partyID)).collection('votes').add(vote)
    await firebase.firestore().collection('partyrooms').doc(String(partyID)).collection('queue').doc(vote.requestID).update({ upVotes: firebase.firestore.FieldValue.increment(1) })
    return voteSnap.id
  }

  static async removeVoteForSong (partyID: string, vote: Vote) {
    await firebase.firestore().collection('partyrooms').doc(String(partyID)).collection('votes').doc(vote.voteID).delete()
    await firebase.firestore().collection('partyrooms').doc(String(partyID)).collection('queue').doc(vote.requestID).update({ upVotes: firebase.firestore.FieldValue.increment(-1) })
  }
}
